import { avatarColor, getInitials } from '../../lib/format';

const SIZES = {
  sm: 'h-8 w-8 text-[11px]',
  md: 'h-10 w-10 text-xs',
  lg: 'h-12 w-12 text-sm',
  // Conversation header: 40px on phones so the bar stays compact, full size
  // from lg up where the header has room to breathe.
  header: 'h-10 w-10 text-[12px] lg:h-12 lg:w-12 lg:text-sm',
  // Sidebar header: 32px on phones, 36px from sm up. The avatar sits inside a
  // 44/40px button, so it stays the smallest box in that row while the button
  // around it keeps the tap target.
  headerSm: 'h-8 w-8 text-[11px] sm:h-9 sm:w-9',
};

/**
 * Avatar with an optional presence dot.
 *
 * Renders the real image when the API supplies one (`user.avatar`,
 * `otherPartyAvatar`) and falls back to deterministic initials, so a missing
 * avatar can never render broken.
 */
export default function Avatar({ name = '', src, online, size = 'md', className = '' }) {
  // An unknown size falls back to `md` rather than rendering an avatar with no
  // dimensions at all.
  const dimensions = SIZES[size] ?? SIZES.md;

  return (
    <span className={`relative inline-flex shrink-0 ${className}`}>
      {src ? (
        <img
          src={src}
          alt=""
          loading="lazy"
          className={`rounded-full object-cover ring-2 ring-surface ${dimensions}`}
        />
      ) : (
        <span
          aria-hidden="true"
          className={`inline-flex items-center justify-center rounded-full font-semibold tracking-wide text-white ring-2 ring-surface ${dimensions} ${avatarColor(name)}`}
        >
          {getInitials(name)}
        </span>
      )}

      {typeof online === 'boolean' && (
        <span
          className={`absolute -right-0.5 -bottom-0.5 h-3 w-3 rounded-full ring-2 ring-surface ${
            online ? 'bg-online' : 'bg-ink-3'
          }`}
        >
          <span className="sr-only">{online ? 'Online' : 'Offline'}</span>
        </span>
      )}
      <span className="sr-only">{name}</span>
    </span>
  );
}
